<template>
  <tr>
    <td>
      <div class="truncate" style="max-width:150px" v-text="fss.rliss"></div>
    </td>
    <td>
      <div class="truncate" style="max-width:400px">
        <router-link :to="url" v-text="fss.agency_name"></router-link>
      </div>
    </td>
    <td>
      <template v-if="fss.statut_id_m1==fss.statut_id_0">
        {{acronym_statut(fss.statut_id_m1)}}
      </template>
      <template v-else="">
        {{acronym_statut(fss.statut_id_m1)}} &rarr; {{acronym_statut(fss.statut_id_0)}}
      </template>
    </td>
    <td v-text="fss.statut_plan_0"></td>

    <td :class="clienteleClass" style="text-align: center;">
      {{clients_m1}} &rarr; {{clients_0}}
    </td>

    <td :class="hrClass" style="text-align: center;">
      <template v-if="fss.statut_id_m1==4">{{fss.hr_ni_actuel_m1}}</template>
      <template v-else="">{{fss.hr_id_actuel_m1}}</template>
      &rarr;
      <template v-if="fss.statut_id_0==4">{{fss.hr_ni_actuel_0}}</template>
      <template v-else="">{{fss.hr_id_actuel_0}}</template>
    </td>

  </tr>
</template>

<style>
td.centre {
  text-align: center;
}

div.truncate {
  /* display: inline-block; */
  /* width: 400px; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<script>

// Ce fichier est encore en développement, et non utilisé

export default {
  name: 'RHrow',
  props: {
    fss: Object
  },
  computed: {
    url() {
      return '/on/rh/'+this.fss.agency_id;
    },
    hrClass() {
      const a = this.fss.statut_id_m1==4 ?
        this.fss.hr_ni_actuel_m1 : this.fss.hr_id_actuel_m1;
      const b = this.fss.statut_id_0==4 ?
        this.fss.hr_ni_actuel_0 : this.fss.hr_id_actuel_0;

      if(a==b)
        return "";
      if(b==0) // flag no entries
        return "table-secondary"

      if(Math.abs(b-a)<=2)
        return "";
      const percentChange = 100*(b-a)/a;
      if(percentChange>=25) return "table-success";
      if(percentChange>=10) return "table-info";
      if(percentChange<=-25) return "table-danger";
      if(percentChange<=-10) return "table-warning";
      return "";
    },

    clienteleClass() {
      // const a = this.fss.clientele_m1;
      // const b = this.fss.clientele_0;
      // if(b==0 & a!=0)
      //   return "table-danger";
      // if(b==0) // flag no entries
      //   return "table-warning";
      return"";
    },

    clients_m1() {
      if(this.fss.clientele_m1!=0)
        return this.fss.clientele_m1;
      // if(this.fss.visites_m1!=0)
      //   return "V: "+this.fss.visites_m1;
      return 0;
    },
    clients_0() {
      if(this.fss.clientele_0!=0)
        return this.fss.clientele_0;
      // if(this.fss.visites_0!=0)
      //   return "V: "+this.fss.visites_0;
      return 0;
    },

  },
  methods: {

    percent(a, b) {
      if(b==0) return "n/a";
      return (100*a/b).toFixed(1) + "%";
    },
    remplis(a, b) {
      return a.toString() + "/" + b.toString();
    },

    acronym_statut(statut_id) {
      switch (statut_id) {
        case 1:
          return "I";
        case 2:
          return "DP";
        case 3:
          return "DC";
        case 4:
          return "NI"

      }
      return "";
    },

    diff_style(v1, v2) {
      if(v1 == v2)
        return "";
      if(v2 == 1)
        return "table-success";
      return "table-danger";
    }
  }
}
</script>
<style>
progress {
  width: 100px;
}
</style>
